// @flow
import * as React from 'react';
import { SearchableSelect } from 'components/Select';
import { isEmpty } from 'utils/functional';

const { useMemo, useState } = React;

const TimezoneSelect = (props: { value: string, ... }) => {
  const [timezones, setTimezones] = useState([]);

  import(/* webpackChunkName: "timezoneList" */ 'utils/timezoneList').then(l =>
    setTimezones(l.default)
  );

  const options = useMemo(
    () =>
      timezones.map(([t, label]) => ({
        label: label.replace(/_/g, ' '),
        value: t
      })),
    [timezones]
  );

  const filterOption = ({ label }, string) => {
    const labelParts = label.toLowerCase().split(/[^A-Za-z]/);
    const searchParts = string.toLowerCase().split(/[^A-Za-z]/);

    return searchParts.every(searchPart =>
      labelParts.some(part => part.includes(searchPart))
    );
  };

  return isEmpty(timezones) ? (
    <></>
  ) : (
    <SearchableSelect
      options={options}
      maxSelected={1}
      searchable
      filterOption={filterOption}
      {...props}
    />
  );
};

export default TimezoneSelect;
